import React from 'react';
import { mathCalculators } from './ConstantsMathCalculator';
import SharedHelmet from '.././Helmet';
const TITLE = 'حواسب الرياضيات - حواسب مجانية لحساب النسب المئوية والمساحات والأشكال الهندسية';
const DESCRIPTION = 'استكشف مجموعة حواسب الرياضيات المجانية، بما في ذلك حواسب حساب النسب المئوية ومحيطات الأشكال وحسابات هندسية مختلفة.';
const KEYWORDS = 'حواسب الرياضيات، حواسب مجانية، حاسبة النسب المئوية، حاسبة رتبة الوسيط، حاسبة محيط الأسطوانة، حاسبة مساحة الخزان، حاسبة طول ضلع المربع، حاسبة نسبة الحضور والغياب، حاسبة كثافة السكان، حاسبة خمس المبلغ، حاسبة نسبة 5%، حاسبة نسبة 10%، حاسبة نسبة 15%، حاسبة نسبة 20%، حاسبة نسبة 25%، حاسبة نسبة 30%، حاسبة نسبة 35%، حاسبة نسبة 40%، حاسبة نسبة 75%';
const OG_URL = 'https://do-calculate.com/ar/math-calculators';
function CalculatorsList() {
    return (
        <div className="container rtl-container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div  >
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-secondary" role="alert">
                    <p>{DESCRIPTION} </p>
                </div>
            </div>
            <hr/>
            <table >
                <thead>
                    <tr >
                        <th >الحاسبة</th>
                        <th >الوصف</th>
                    </tr>
                </thead>
                <tbody>
                    {mathCalculators.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}
export default CalculatorsList;
